import { Skeleton } from '@/components/ui/skeleton'

export const ScoreFormLoading = () => {
	return (
		<div className='flex flex-1 flex-col overflow-hidden'>
			{/* Header */}
			<div className='border-neutral-200 border-b px-10 pt-6 pb-6'>
				<div className='flex items-center gap-6'>
					<Skeleton height={44} width={44} />
					<div className='flex flex-col gap-2'>
						<Skeleton height={24} width={200} />
						<div className='flex items-center gap-6'>
							<Skeleton height={20} width={100} />
							<Skeleton height={20} width={160} />
							<Skeleton height={20} width={80} />
						</div>
					</div>
					<div className='ml-auto'>
						<Skeleton height={36} width={100} />
					</div>
				</div>
			</div>

			{/* Main content */}
			<div className='grid h-full grid-cols-[1.5fr_2fr] overflow-hidden'>
				{/* Left panel */}
				<div className='overflow-auto border-neutral-200 border-r pr-6 pb-6 pl-8'>
					<div className='flex flex-col gap-1 pt-6 pb-4'>
						<Skeleton height={16} width={180} />
						<Skeleton height={14} width={240} />
					</div>

					<div className='flex flex-col gap-4'>
						<div className='flex flex-col gap-2.5'>
							<Skeleton height={18} width={120} />
							<Skeleton height={40} />
						</div>

						<div className='flex flex-col gap-2'>
							<Skeleton height={18} width={100} />
							<Skeleton height={14} width={280} />
						</div>

						{Array.from({ length: 3 }).map((_, i) => (
							<div
								className='flex flex-col gap-2'
								key={`yn-${i + 1}`}
							>
								<Skeleton height={16} width={200} />
								<Skeleton height={14} width={260} />
								<div className='flex gap-2'>
									<Skeleton height={32} width={60} />
									<Skeleton height={32} width={60} />
								</div>
							</div>
						))}
					</div>
				</div>

				{/* Right side */}
				<div className='flex flex-col gap-8 overflow-auto px-6'>
					<div className='mt-6 flex max-h-125 shrink-0 gap-6 overflow-hidden'>
						<div className='min-w-0 flex-1'>
							<Skeleton className='h-full min-h-80 w-full rounded-md' />
						</div>
						<div className='flex shrink-0 flex-col gap-2'>
							{Array.from({ length: 6 }).map((_, i) => (
								<Skeleton
									height={60}
									key={`thumb-${i + 1}`}
									width={80}
								/>
							))}
						</div>
					</div>

					<div className='flex flex-col gap-4'>
						<div className='flex flex-col gap-1'>
							<Skeleton height={24} width={140} />
							<Skeleton height={18} width={260} />
						</div>
						{Array.from({ length: 2 }).map((_, i) => (
							<div
								className='grid grid-cols-[0.5fr_2fr] items-center gap-4 border-neutral-200 border-b py-4'
								key={`detail-${i + 1}`}
							>
								<Skeleton height={14} width={80} />
								<div className='flex flex-wrap gap-2'>
									{Array.from({ length: 5 }).map((_, j) => (
										<Skeleton
											height={28}
											key={`chip-${i + 1}-${j + 1}`}
											width={80}
										/>
									))}
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
